import { SearchEntity } from '~/types/search'
import { LoftwareButtonStyle } from '~/types/ui'

export const COPY_FEEDBACK_DURATION_MS = 1500
export const ERROR_DETAILS_PREVIEW_ROWS = 3
export const LOADING_BAR_DONE_DURATION_MS = 200
export const ACCESS_RESTRICTED_TOAST_DELAY_MS = 500
export const CLAIM_STATUS_FEEDBACK_DELAY_MS = 2000
export const RECENTLY_UPDATED_HIGHLIGHT_MS = 1600
export const ALREADY_ONBOARDED_TOAST_DELAY_MS = 5000
export const USER_ONBOARDING_REDIRECT_DELAY_MS = 500
export const USER_ALREADY_ONBOARDED_TOAST_DELAY_MS = 2000
export const USER_ONBOARDING_LOGIN_TOAST_DELAY_MS = 4000
export const COUNTRY_CHANGE_STATE_RESET_DELAY_MS = 200
export const PARTNER_REFRESH_DELAY_MS = 500
export const IMPERSONATION_CHECK_DELAY_MS = 450
export const IMPERSONATION_FAILED_MESSAGE_DURATION_MS = 1800
export const TABLE_SPINNER_DELAY_MS = 100
export const TABLE_SKELETON_DELAY_MS = 300

export const ACCESS_LINK_COLUMN_OPTIONS = { accessLink: ['url'] }

export const TABLE_DEFAULT_COLUMN_WIDTH = 160
export const TABLE_SELECTION_COLUMN_WIDTH = 52

export const COLUMNS_WITHOUT_TRANSLATION = [
  'payment',
  'status',
  'salesforceCallFailed',
  'contractType',
  'billingPeriod',
  'claimed',
  'role',
]

export const FILTER_PRESETS_FOOTER_HEIGHT = 48
export const FILTER_PRESETS_ITEM_HEIGHT = 30
export const FILTER_PRESETS_CONTAINER_PADDING = 16
export const FILTER_PRESETS_VIEWPORT_MARGIN = 16
export const FILTER_PRESETS_LIST_PADDING = 6
export const FILTER_PRESETS_EMPTY_LIST_HEIGHT = 40
export const FILTER_PRESETS_MIN_LIST_HEIGHT = 80
export const FILTER_PRESETS_DEFAULT_LIST_HEIGHT = 400

export const SEARCH_MAX_HISTORY_ITEMS = 6
export const SEARCH_MIN_QUERY_LENGTH = 2
export const SEARCH_DEBOUNCE_MS = 300
export const SEARCH_SHORTCUT_KEY = 'k'
export const SEARCH_ALL_CATEGORY = 'all'

export const SEARCH_ENTITY_ICONS: Record<SearchEntity, string> = {
  [SearchEntity.PARTNER]: 'BuildingOfficeIcon',
  [SearchEntity.CUSTOMER]: 'HomeModernIcon',
  [SearchEntity.SUBSCRIPTION]: 'Squares2X2Icon',
  [SearchEntity.RESELLER]: 'BuildingOffice2Icon',
}

export const LOFTWARE_BUTTON_STYLES: Record<string, LoftwareButtonStyle> = {
  primary: {
    class: 'btn-loftware primary',
    neutral: 'text-white bg-blue-200 border border-blue-200',
    hovered: 'hover:text-blue-200',
    loading: 'is-loading text-blue-200 ',
  },
  secondary: {
    class: 'btn-loftware secondary',
    neutral: 'text-blue-200 bg-white border border-blue-200 ',
    hovered: 'hover:text-white',
    loading: 'is-loading text-white ',
  },
}

export const MODAL_NO_ACTION = 'none'

export const SIDEBAR_BADGE_MAX_COUNT = 10

export const COLUMN_SETTINGS_PANEL_MAX_WIDTH = 288
export const COLUMN_SETTINGS_VIEWPORT_GUTTER = 12
export const COLUMN_SETTINGS_PANEL_OFFSET = 8
